import { render } from "./Settings.vue?vue&type=template&id=273d171e&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=273d171e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-273d171e"

export default script